module.exports = __webpack_public_path__ + "static/media/insulation_allImpact_10y_n.ac9be3a8.csv";